import { useState } from 'react';
import { Button } from '@pixlide/ui';
import { useCancelSubscription, useResumeSubscription } from '@/api/queries/dashboard';

/** Valeur numérique de `SubscriptionStatus.PendingCancellation` côté backend. */
export const SUBSCRIPTION_STATUS_PENDING_CANCELLATION = 3;

/** Bouton de résiliation en deux temps : évite une coupure de service sur un clic accidentel. */
export function CancelSubscriptionButton() {
  const [confirming, setConfirming] = useState(false);
  const cancelSubscription = useCancelSubscription();

  if (confirming) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="danger"
          isLoading={cancelSubscription.isPending}
          onClick={() => {
            cancelSubscription.mutate(undefined, {
              onSuccess: () => setConfirming(false),
            });
          }}
        >
          Confirmer la résiliation
        </Button>
        <Button variant="ghost" onClick={() => setConfirming(false)}>
          Annuler
        </Button>
      </div>
    );
  }

  return (
    <Button variant="secondary" onClick={() => setConfirming(true)}>
      Résilier mon abonnement
    </Button>
  );
}

/** Permet au client de revenir sur une résiliation qu'il a demandée. */
export function ResumeSubscriptionButton() {
  const resumeSubscription = useResumeSubscription();

  return (
    <Button
      variant="primary"
      isLoading={resumeSubscription.isPending}
      onClick={() => resumeSubscription.mutate()}
    >
      Reprendre mon abonnement
    </Button>
  );
}
